import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn("GA: REACT_APP_GA_MEASUREMENT_ID not set, analytics disabled");
    return;
  }
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (category, action, label, value) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({
    category,
    action,
    ...(label && { label }),
    ...(value !== undefined && { value }),
  });
};

// ── Pre-built event helpers ──

export const gaLoginSuccess = (userCode, role) => {
  trackEvent("Auth", "Login Success", `${userCode}_${role}`);
};

export const gaLoginFailed = (userCode, reason) => {
  trackEvent("Auth", "Login Failed", `${userCode}_${reason || "unknown"}`);
};

export const gaLogout = (userCode, reason) => {
  trackEvent("Auth", "Logout", `${userCode}_${reason || ""}`);
};

export const gaPasswordChanged = (userCode) => {
  trackEvent("Auth", "Password Changed", userCode);
};

export const gaCallInitiated = (leadId, advisorCode, callSource) => {
  trackEvent(
    "Call",
    "Call Initiated",
    `LeadID_${leadId}_${advisorCode}_${callSource}`
  );
};

export const gaCallEnded = (leadId, advisorCode, duration) => {
  trackEvent("Call", "Call Ended", `LeadID_${leadId}_${advisorCode}`, duration);
};

export const gaDispositionSaved = (leadId, advisorCode, mainDisposition, subDisposition) => {
  trackEvent(
    "Disposition",
    "Disposition Saved",
    `LeadID_${leadId}_${advisorCode}_${mainDisposition}_${subDisposition}`
  );
};

export const gaLeadViewed = (leadId, advisorCode) => {
  trackEvent("Lead", "Lead Viewed", `LeadID_${leadId}_${advisorCode}`);
};

export const gaLeadSearched = (filters, advisorCode) => {
  trackEvent("Lead", "Lead Searched", `${advisorCode}_${JSON.stringify(filters)}`);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  gaLoginSuccess,
  gaLoginFailed,
  gaLogout,
  gaPasswordChanged,
  gaCallInitiated,
  gaCallEnded,
  gaDispositionSaved,
  gaLeadViewed,
  gaLeadSearched,
};
